import React, { Component } from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { languageMap } from 'constants/Language'
import { isStage } from '../../../../../shared/domainUtils.js'

const liveCasino = {
  ru: '/img/jacktop-games-live-casino-games-ru.png',
  en: '/img/jacktop-games-live-casino-games-en.png',
}

const tryNew = {
  ru: '/img/jacktop-games-try-new-ru.png',
  en: '/img/jacktop-games-try-new-en.png',
}

class JacktopGamesBanner extends Component {
  onClick = () => {
    const { isActiveSlide } = this.props
    if (isActiveSlide)
      this.props.push(`/games?provider=${isStage ? 22 : 4}`)
  }

  render() {
    const { langId } = this.props
    const locale = languageMap[langId].name

    const src = tryNew[locale] || tryNew['ru']
    const liveCasinoSrc = liveCasino[locale] || liveCasino['ru']

    return (
      <div className="jacktop-games-banner" onClick={this.onClick}>
        <img src={src} alt="Live Casino Games" />
        <img src={liveCasinoSrc} alt="Live Casino Games" />
        <img src={'/img/jacktop-banner-logo.png'} alt="Jacktop logo" />
        <img src={'/img/jacktop-banner-girl.png'} alt="Jacktop Girl" />
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    langId: state.application.get('languageId'),
  }
}

export default connect(mapStateToProps, { push })(JacktopGamesBanner)



// WEBPACK FOOTER //
// ./js/sport-betting/components/main-page/banners/jacktop-games/JacktopGamesBanner.jsx